// One field, dispatched by type to its v2 renderer. attachment and group
// have no v2 skin yet and fall back to the v1 Field component so nothing
// a definition can hold renders as a hole.

import React from "react";
import { useFormContext } from "react-hook-form";

import Field from "components/Field";
import { FieldConfig } from "components/Form/types";

import AddressField from "./AddressField";
import ChoicesField from "./ChoicesField";
import DropdownField from "./DropdownField";
import FullNameField from "./FullNameField";
import LongTextField from "./LongTextField";
import MaskedField from "./MaskedField";
import SectionHeadingField from "./SectionHeadingField";
import TextField from "./TextField";
import { V2FieldProps } from "./types";
import YesNoField from "./YesNoField";

interface V2FieldRendererProps extends V2FieldProps {
  fallbackConfig: FieldConfig;
}

function LegacyField({ config }: { config: FieldConfig }) {
  const { control, register, setValue } = useFormContext();
  return (
    <Field
      field={config}
      control={control}
      register={register}
      setValue={setValue}
    />
  );
}

export default function V2Field({
  field,
  onCommit,
  fallbackConfig,
}: V2FieldRendererProps) {
  switch (field.type) {
    case "short_text":
    case "email":
    case "number":
      return <TextField field={field} onCommit={onCommit} />;
    case "ssn":
    case "date":
    case "phone_number":
      return <MaskedField field={field} onCommit={onCommit} />;
    case "long_text":
      return <LongTextField field={field} onCommit={onCommit} />;
    case "dropdown":
      return <DropdownField field={field} onCommit={onCommit} />;
    case "choices":
      return <ChoicesField field={field} onCommit={onCommit} />;
    case "yes_no":
      return <YesNoField field={field} onCommit={onCommit} />;
    case "full_name":
      return <FullNameField field={field} onCommit={onCommit} />;
    case "location":
      return <AddressField field={field} onCommit={onCommit} />;
    case "section_heading":
      return <SectionHeadingField field={field} />;
    default:
      return <LegacyField config={fallbackConfig} />;
  }
}
